import { PARKING_KEYPADS, ParkingKeypadType } from 'constants/parking';
import useParking from 'hooks/fetch/parking/useParking';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useColorSetStore from 'stores/colorSet';
import { InOut } from 'types/feature/parking.type';
import styles from './ParkingKeypad.module.scss';

type Props = {
  setCarList: (carList: InOut[]) => void;
  setShowCarList: (isShowCarList: boolean) => void;
};

export default function ParkingKeypad({ setCarList, setShowCarList }: Props) {
  const [carNumber, setCarNumber] = useState<string[]>([]);

  const { t } = useTranslation();
  const { getInOutList } = useParking();

  const colorSetStore = useColorSetStore();

  const onClickKeypad = async (keypad: ParkingKeypadType) => {
    if (keypad.type === 'number') {
      if (carNumber.length >= 4) {
        setCarNumber([]);
      }
      setCarNumber(prev => [...prev, keypad.label]);
    } else if (keypad.type === 'backspace') {
      if (carNumber.length < 1) return;
      setCarNumber(prev => prev.slice(0, -1));
    } else if (keypad.type === 'search') {
      if (carNumber.length !== 4) return;
      const fullCarNumber = carNumber.join('');
      const inOutList = await getInOutList(fullCarNumber);
      setCarList(inOutList);
      setShowCarList(true);
    }
  };
  return (
    <div className={styles.ParkingKeypad}>
      <div className={styles.keypad}>
        <div className={styles.numbers_and_desc}>
          <div className={styles.number_inputs}>
            <div
              style={{
                color: colorSetStore.main,
                borderColor: colorSetStore.main,
              }}
              className={styles.number_box}
            >
              <div>{carNumber[0]}</div>
            </div>

            <div
              style={{
                color: colorSetStore.main,
                borderColor: colorSetStore.main,
              }}
              className={styles.number_box}
            >
              <div>{carNumber[1]}</div>
            </div>

            <div
              style={{
                color: colorSetStore.main,
                borderColor: colorSetStore.main,
              }}
              className={styles.number_box}
            >
              <div>{carNumber[2]}</div>
            </div>

            <div
              style={{
                color: colorSetStore.main,
                borderColor: colorSetStore.main,
              }}
              className={styles.number_box}
            >
              <div>{carNumber[3]}</div>
            </div>
          </div>

          <div className={styles.description}>{t('parking.keypad.description')}</div>
        </div>

        <div className={styles.numbers}>
          {PARKING_KEYPADS.map((keypad, index) => {
            const isBackspace = keypad.type === 'backspace';
            const isSearch = keypad.type === 'search';
            return (
              <div
                key={index}
                onClick={() => onClickKeypad(keypad)}
                style={{
                  backgroundColor: isBackspace || isSearch ? colorSetStore.main : '',
                }}
                className={styles.keypad}
              >
                {isBackspace ? (
                  <img className={styles.backspace_icon} src={keypad.iconPath} alt='backspace' />
                ) : (
                  <div className={`${styles.label} ${isSearch && styles.search}`}>
                    {isSearch ? t('parking.keypad.search') : keypad.label}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
